/* ============================================================
   TheMeowPicks — browser-based wishlist (no app, no login).
   Load globally: add this before </body> in layout/theme.liquid:
     <script src="{{ 'tmp-wishlist.js' | asset_url }}" defer></script>
   Wishlist page: uses the "wishlist" page template (page.wishlist.liquid),
   which contains <div id="tmp-wishlist-root"></div>.
   ============================================================ */
(function () {
  var KEY = 'tmp_wishlist_v1';
  var EMPTY = '<div class="tmp-wish-empty">Your wishlist is empty.<br>Tap the heart on any product to save it here.</div>';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function writeRaw(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function has(h) { return read().indexOf(h) > -1; }
  function toggle(h) { var a = read(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.unshift(h); writeRaw(a); refresh(); }

  function heart(filled) {
    return filled
      ? '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5"><path d="M12 21s-7.5-4.6-10-9.3C.6 8.9 2 5.5 5.2 5.1c2-.25 3.5.9 4.8 2.4 1.3-1.5 2.8-2.65 4.8-2.4 3.2.4 4.6 3.8 3.2 6.6C19.5 16.4 12 21 12 21z"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 20.3s-6.8-4.2-9.1-8.5C1.7 9.3 3 6.4 5.7 6.1c1.8-.2 3.2.8 4.3 2.1l2 2.1M12 20.3s6.8-4.2 9.1-8.5C22.3 9.3 21 6.4 18.3 6.1c-1.8-.2-3.2.8-4.3 2.1"/></svg>';
  }

  function css() {
    if (document.getElementById('tmp-wish-css')) return;
    var s = document.createElement('style'); s.id = 'tmp-wish-css';
    s.textContent =
      /* card heart */
      '.tmp-prod{position:relative;}' +
      '.tmp-wish{position:absolute;top:12px;right:12px;z-index:3;width:30px;height:30px;border:0;background:none;padding:0;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#15140F;opacity:0;transition:opacity .2s,transform .2s;transform:scale(.9);filter:drop-shadow(0 1px 2px rgba(255,255,255,.9)) drop-shadow(0 0 5px rgba(255,255,255,.55));}' +
      '.tmp-prod:hover .tmp-wish,.tmp-wish.is-saved{opacity:1;transform:none;}' +
      '.tmp-wish.is-saved{color:#B06B54;}' +
      '.tmp-wish:hover{transform:scale(1.12);}' +
      '.tmp-wish svg{width:22px;height:22px;}' +
      '@media(hover:none){.tmp-wish{opacity:1;transform:none;}}' +
      /* header icon: outline when empty, filled when it has items (no count) */
      '.tmp-wish-head{position:relative;display:inline-flex;align-items:center;color:currentColor;transition:transform .2s;}' +
      '.tmp-wish-head:hover{transform:scale(1.06);}' +
      '.tmp-wish-head svg{width:21px;height:21px;}' +
      '.tmp-wish-head.has-items,.header__icons .tmp-wish-head.has-items,.header__mobile-lead .tmp-wish-head.has-items{color:#B06B54 !important;}' +
      '.tmp-wish-head.has-items svg,.header__icons .tmp-wish-head.has-items svg,.header__mobile-lead .tmp-wish-head.has-items svg{fill:#B06B54 !important;color:#B06B54 !important;}' +
      /* product-page wishlist — heart icon beside Add to cart */
      '.tmp-pd-ctarow{display:flex;align-items:stretch;gap:8px;margin-bottom:10px;}' +
      '.tmp-pd-ctarow>[data-atc]{flex:1 1 auto;width:auto !important;min-width:0;margin:0 !important;}' +
      '.tmp-wish-add{flex:0 0 auto;width:56px;align-self:stretch;display:inline-flex;align-items:center;justify-content:center;padding:0;background:transparent;color:#4B463E;border:1px solid #D8D2C6;border-radius:0;box-shadow:none;cursor:pointer;-webkit-appearance:none;appearance:none;transition:background .25s ease,color .25s ease,border-color .25s ease;}' +
      '.tmp-wish-add svg{width:21px;height:21px;flex:0 0 auto;transition:transform .25s cubic-bezier(.22,.78,.24,1),color .25s ease;}' +
      '.tmp-wish-add.is-saved{color:#B06B54;border-color:#B06B54;background:#FBF5F1;}' +
      '.tmp-wish-add.is-saved svg{color:#B06B54;}' +
      '@media(hover:hover){.tmp-wish-add:hover{background:#F2ECE3;border-color:#B9B2A3;color:#B06B54;}.tmp-wish-add:hover svg{color:#B06B54;transform:scale(1.1);}.tmp-wish-add.is-saved:hover{background:#F7ECE6;border-color:#B06B54;}}' +
      '@media(max-width:640px){.tmp-wish-add{width:52px;}}' +
      /* wishlist page */
      '#tmp-wishlist-root .tmp-wish-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:clamp(14px,1.6vw,24px);}' +
      '@media(max-width:900px){#tmp-wishlist-root .tmp-wish-grid{grid-template-columns:repeat(2,1fr);}}' +
      '#tmp-wishlist-root .tmp-prod{display:block;color:#1A1813;text-decoration:none;}' +
      '#tmp-wishlist-root .tmp-pim{position:relative;aspect-ratio:1/1.04;overflow:hidden;background:linear-gradient(150deg,#EDE6D9,#E5DCCC);}' +
      '#tmp-wishlist-root .tmp-pim img{width:100%;height:100%;object-fit:cover;}' +
      '#tmp-wishlist-root .tmp-st{margin-top:15px;font-size:13.5px;font-weight:500;color:#1A1813;}' +
      '#tmp-wishlist-root .tmp-nm{font-size:13.5px;color:#6E6A60;margin-top:3px;}' +
      '#tmp-wishlist-root .tmp-pc{font-size:13.5px;color:#1A1813;margin-top:9px;}' +
      '#tmp-wishlist-root .tmp-at{color:#9C988D;font-size:12px;}' +
      '#tmp-wishlist-root .tmp-ptag{position:absolute;top:14px;left:14px;display:inline-flex;align-items:center;gap:5px;font-size:9.5px;letter-spacing:.1em;text-transform:uppercase;color:#6E6A60;background:#F8F7F2;padding:4px 9px;border:1px solid #E4E0D5;}' +
      '#tmp-wishlist-root .tmp-ptag svg{width:9px;height:9px;}' +
      '.tmp-wish-item{position:relative;will-change:transform,opacity;}' +
      '.tmp-wish-remove{margin-top:10px;font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#9C988D;background:none;border:0;padding:0;cursor:pointer;border-bottom:1px solid transparent;transition:color .2s,border-color .2s;}' +
      '.tmp-wish-remove:hover{color:#15140F;border-color:#15140F;}' +
      '.tmp-wish-empty{font-size:15px;color:#6E6A60;padding:40px 0;line-height:1.7;}';
    (document.head || document.documentElement).appendChild(s);
  }

  /* ---- header icon ---- */
  function header() {
    if (document.querySelector('.tmp-wish-head')) return;
    var host = document.querySelector('.header__icons') || document.querySelector('.header__icon-list') ||
      (document.querySelector('.header__icon') && document.querySelector('.header__icon').parentNode);
    if (!host) return;
    var a = document.createElement('a');
    a.href = '/pages/wishlist';
    a.className = 'header__icon header__icon--wishlist link focus-inset tmp-wish-head';
    a.setAttribute('aria-label', 'Wishlist');
    host.insertBefore(a, host.firstChild);
    updateHeader();
  }
  function updateHeader() {
    var n = read().length;
    var els = document.querySelectorAll('.tmp-wish-head');
    for (var i = 0; i < els.length; i++) {
      els[i].innerHTML = heart(n > 0);
      els[i].classList.toggle('has-items', n > 0);
      els[i].setAttribute('aria-label', n > 0 ? ('Wishlist, ' + n + ' saved') : 'Wishlist');
    }
  }

  /* ---- product cards (collection, search, carousels) ---- */
  function hearts() {
    var cards = document.querySelectorAll('.tmp-prod[data-handle]:not(.tmp-has-wish)');
    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        card.classList.add('tmp-has-wish');
        var h = card.getAttribute('data-handle'); if (!h) return;
        var pim = card.querySelector('.tmp-pim'); if (!pim) return;
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'tmp-wish'; btn.setAttribute('aria-label', 'Save to wishlist');
        btn.innerHTML = heart(has(h));
        btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(h); });
        pim.appendChild(btn);
      })(cards[i]);
    }
  }
  function updateCards() {
    var list = read();
    var btns = document.querySelectorAll('.tmp-prod[data-handle] .tmp-wish');
    for (var i = 0; i < btns.length; i++) {
      var card = btns[i].closest('.tmp-prod'); if (!card) continue;
      var saved = list.indexOf(card.getAttribute('data-handle')) > -1;
      btns[i].classList.toggle('is-saved', saved);
      btns[i].innerHTML = heart(saved);
    }
  }

  /* ---- product page "Add to wishlist" button ---- */
    function productButton() {
    var buy = document.querySelector('.tmp-pd-buy');
    if (!buy || buy.querySelector('.tmp-wish-add')) return;
    var h = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (!h) return;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'tmp-wish-add'; btn.setAttribute('data-handle', h);
    setProductBtn(btn, has(h));
    btn.addEventListener('click', function (e) { e.preventDefault(); toggle(h); });
    // place the heart beside "Add to cart" in a shared row (falls back to appending)
    var atc = buy.querySelector('[data-atc]') || buy.querySelector('.shopify-product-form .tmp-btn');
    if (atc && atc.parentNode && !atc.closest('.tmp-pd-ctarow')) {
      var row = document.createElement('div');
      row.className = 'tmp-pd-ctarow';
      atc.parentNode.insertBefore(row, atc);
      row.appendChild(atc);
      row.appendChild(btn);
    } else if (atc && atc.closest('.tmp-pd-ctarow')) {
      atc.closest('.tmp-pd-ctarow').appendChild(btn);
    } else {
      buy.appendChild(btn);
    }
  }
   function setProductBtn(btn, saved) {
    btn.classList.toggle('is-saved', saved);
    btn.innerHTML = heart(saved);
    var label = saved ? 'Saved to wishlist' : 'Add to wishlist';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);
  }
  function updateProductBtn() {
    var btn = document.querySelector('.tmp-wish-add[data-handle]');
    if (btn) setProductBtn(btn, has(btn.getAttribute('data-handle')));
  }

  /* ---- wishlist page render ---- */
  var pageBusy = false;
  function renderPage() {
    var root = document.getElementById('tmp-wishlist-root'); if (!root || pageBusy) return;
    var list = read(); var sig = list.join(',');
    if (root.getAttribute('data-rendered') === sig) return;
    if (!list.length) { root.innerHTML = EMPTY; root.setAttribute('data-rendered', ''); return; }
    root.setAttribute('data-rendered', sig);
    pageBusy = true;
    root.innerHTML = '<div class="tmp-wish-grid"></div>';
    var grid = root.querySelector('.tmp-wish-grid');
    var done = 0;
    list.forEach(function (h, idx) {
      fetch('/products/' + h + '.js', { cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        done++;
        if (p) {
          var aff = (p.tags || []).some(function (t) { return /^affiliate$/i.test(t); });
          var img = p.featured_image || (p.images && p.images[0]) || '';
          if (img.indexOf('//') === 0) img = 'https:' + img;
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=700';
          var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
          var price;
          try { price = (p.price / 100).toLocaleString(undefined, { style: 'currency', currency: cur }); } catch (e) { price = '$' + (p.price / 100).toFixed(2); }
          var arrow = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 17L17 7M17 7H9M17 7v8"/></svg>';
          var item = document.createElement('div'); item.className = 'tmp-wish-item'; item.style.order = idx;
          item.innerHTML =
            '<a class="tmp-prod" href="/products/' + p.handle + '"><div class="tmp-pim">' +
            (img ? '<img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '') + '" loading="lazy">' : '') +
            (aff ? '<span class="tmp-ptag">' + arrow + p.vendor + '</span>' : '') +
            '</div><div class="tmp-st">' + p.vendor + '</div><div class="tmp-nm">' + p.title + '</div>' +
            '<div class="tmp-pc">' + price + (aff ? ' <span class="tmp-at">at ' + p.vendor + '</span>' : '') + '</div></a>' +
            '<button class="tmp-wish-remove" data-h="' + p.handle + '">Remove</button>';
          grid.appendChild(item);
        }
        if (done === list.length) pageBusy = false;
      }).catch(function () { done++; if (done === list.length) pageBusy = false; });
    });
  }

  /* smooth, in-place removal on the wishlist page (fade the item, FLIP the rest) */
  function removeFromPage(item, h) {
    var grid = item.parentNode; if (!grid) { toggle(h); return; }
    var kids = Array.prototype.slice.call(grid.children);
    var firstRects = kids.map(function (el) { return el.getBoundingClientRect(); });
    var a = read(); var i = a.indexOf(h); if (i > -1) a.splice(i, 1); writeRaw(a);
    var root = document.getElementById('tmp-wishlist-root'); if (root) root.setAttribute('data-rendered', a.join(','));
    updateHeader(); updateCards(); updateProductBtn();
    item.style.transition = 'opacity .24s ease, transform .24s ease';
    item.style.pointerEvents = 'none';
    requestAnimationFrame(function () { item.style.opacity = '0'; item.style.transform = 'scale(.94)'; });
    window.setTimeout(function () {
      item.remove();
      if (!a.length) { if (root) { root.innerHTML = EMPTY; root.setAttribute('data-rendered', ''); } return; }
      var rest = Array.prototype.slice.call(grid.children);
      rest.forEach(function (el) {
        var idx = kids.indexOf(el); if (idx < 0) return;
        var last = el.getBoundingClientRect();
        var dx = firstRects[idx].left - last.left, dy = firstRects[idx].top - last.top;
        if (dx || dy) {
          el.style.transition = 'none';
          el.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
          el.getBoundingClientRect();
          requestAnimationFrame(function () {
            el.style.transition = 'transform .34s cubic-bezier(.22,.61,.36,1)';
            el.style.transform = '';
          });
        }
      });
    }, 250);
  }

  function refresh() { updateCards(); updateHeader(); updateProductBtn(); renderPage(); }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.tmp-wish-remove');
    if (b) { e.preventDefault(); var it = b.closest('.tmp-wish-item'); var h = b.getAttribute('data-h'); if (it) removeFromPage(it, h); else toggle(h); }
  });

  function scan() { header(); hearts(); productButton(); }
  function init() { css(); scan(); refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { scan(); refresh(); });
  window.addEventListener('storage', function (e) { if (!e || e.key === KEY) refresh(); });
  try { var t, mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { scan(); refresh(); }, 150); }); mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
})();